import 'element-ui/lib/theme-chalk/index.css';
import Vue from 'vue'
import App from './App.vue'
import VueRouter from "vue-router"
import Foo from "./xxxvue/Foo.vue"
import Mg from "./xxxvue/mg.vue"
import mglg from "./xxxvue/adminmg.vue"
Vue.use(VueRouter);
import ElementUI from 'element-ui';
Vue.use(ElementUI);
import Vuex from 'vuex';
Vue.use(Vuex);
import store from './vuex/store';
import axios from 'axios';
Vue.prototype.$axios = axios;

// axios.defaults.baseURL   = "http://218.90.187.138:9481/";
// axios.defaults.baseURL =  "http://f21898.ployq.com/";
// axios.defaults.baseURL = "http://129.204.52.13:10080/";
// axios.defaults.baseURL = "http://192.168.3.240/";
// axios.defaults.baseURL = "http://129.204.52.13:10080/";
// axios.defaults.baseURL = "http://101.71.162.196:10080/";

const router = new VueRouter({
    mode: 'history',
    routes: [{
            path: '/mgll',
            component: Mg,
            meta: {
                auth: true
            }
        },
        {
            path: '/login',
            component: Foo
        },
        {
            path: '/mglg',
            component: mglg
        },
        {
            path: '/',
            component: Foo,
            query:{
              passwd:"",
              username:""
            }
        }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(m => m.meta.auth)) {
        // 对路由进行验证
        if (sessionStorage.getItem('username') != null && sessionStorage.getItem('passwd') != null) { // 已经登陆
            next()
        } else {
            // 未登录,跳转到登陆页面，并且带上 将要去的地址，方便登陆后跳转。
            next({ path: '/login', query: { redirect: to.fullPath } })
        }
    } else {
        next()
    }
})

new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js